import React, { useEffect, useState } from "react";
import axios from "axios";
import Topbar from "../components/topbar";
import Sidebar from "../components/sidebar";
import Footer from "../components/footer";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_URL = `${BASE_URL}admin/getdata/get_quickenquiry.php`;

const QuickEnquiry = () => {

  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  /* ================= FETCH ENQUIRIES ================= */
const fetchEnquiries = async () => {
  setLoading(true);
  setMessage("");

  try {
    const res = await axios.get(API_URL, {
      params: { fromDate, toDate }
    });

    console.log("API RESPONSE:", res.data);

    if (res.data.status === "success" && Array.isArray(res.data.data)) {
      setEnquiries(res.data.data);
    } else {
      setEnquiries([]);
      setMessage("No data found");
    }

  } catch (err) {
    console.error(err);
    setEnquiries([]);
    setMessage("Error loading enquiries");
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchEnquiries();
  }, []);

  return (
    <div className="header-light sidebar-dark sidebar-expand">
      <Topbar />

      <div className="content-wrapper">
        <Sidebar />

        <main className="main-wrapper clearfix">
          <div className="widget-list">

            <h4 className="mb-3">Quick Enquiry List</h4>

            {/* FILTER */}
            <div className="card">
              <div className="card-body">

                {message && (
                  <div className="alert alert-info py-2">
                    {message}
                  </div>
                )}

                <div className="row g-3">
                  <div className="col-md-3">
                    <label className="form-label">From Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                    />
                  </div>

                  <div className="col-md-3">
                    <label className="form-label">To Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                    />
                  </div>

                  <div className="col-md-3 d-flex align-items-end">
                    <button
                      className="btn btn-primary w-100"
                      onClick={fetchEnquiries}
                      disabled={loading}
                    >
                      {loading ? "Loading..." : "Filter"}
                    </button>
                  </div>
                </div>

              </div>
            </div>

            {/* LIST */}
            <div className="card mt-4">
              <div className="card-header">View Quick Enquiries</div>

              <div className="card-body p-0">

                {loading ? (
                  <p className="p-3 mb-0">Loading...</p>
                ) : (
                  <table className="table table-bordered mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>#</th>
                        <th>Full Name</th>
                        <th>Email</th>
                        <th>Contact</th>
                        <th>Address</th>
                        <th>Message</th>
                        <th>Date</th>
                      </tr>
                    </thead>

                   <tbody>
                      {enquiries && enquiries.length > 0 ? (
                        enquiries.map((item, index) => (
                          <tr key={item.id}>
                            <td>{index + 1}</td>
                            <td>{item.fullname}</td>
                            <td>{item.email}</td>
                            <td>{item.contact}</td>
                            <td>{item.address}</td>
                            <td>{item.message}</td>
                            <td>{item.created_at}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            No enquiries found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}

              </div>
            </div>

          </div>
        </main>

        <Footer />
      </div>
    </div>
  );
};

export default QuickEnquiry;